import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { buergerportalAuthHeader } from "../components/BuergerPortalGate";

// Bewusst OHNE den zentralen api-Client (der würde einen normalen Auth-
// Header versuchen mitzuschicken) - das Bürgerportal ist eigenständig
// geschützt (siehe BuergerPortalGate), ein einfacher fetch() reicht.
export default function BuergerPortal() {
  const [gremien, setGremien] = useState([]);
  const [sitzungen, setSitzungen] = useState([]);
  const [vorlagen, setVorlagen] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const headers = buergerportalAuthHeader();
    Promise.all([
      fetch("/api/oeffentlich/gremien", { headers }),
      fetch("/api/oeffentlich/sitzungen", { headers }),
      fetch("/api/oeffentlich/vorlagen", { headers }),
    ]).then(async ([rg, rs, rv]) => {
      if (rg.status === 401 || rs.status === 401 || rv.status === 401) {
        localStorage.removeItem("buergerportal_token");
        window.location.reload();
        return;
      }
      setGremien(await rg.json());
      setSitzungen(await rs.json());
      setVorlagen(await rv.json());
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{ padding: 40 }}>Wird geladen…</div>;

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Ratsinformation</h1>
      <div style={{ fontSize: 14, color: "#666", marginBottom: 32 }}>
        Öffentliche Sitzungen, Gremien und Dokumente
      </div>

      <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Gremien</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 32 }}>
        {gremien.map(g => (
          <span key={g.id} style={{ background: "#f0f0f0", padding: "6px 12px", borderRadius: 16, fontSize: 13 }}>
            {g.name}
          </span>
        ))}
        {gremien.length === 0 && <span style={{ color: "#999", fontSize: 13 }}>Keine Gremien vorhanden.</span>}
      </div>

      <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Öffentliche Sitzungen</h2>
      {sitzungen.length === 0 && (
        <div style={{ color: "#999", fontSize: 13 }}>Aktuell keine öffentlichen Sitzungen veröffentlicht.</div>
      )}
      {sitzungen.map(s => (
        <Link key={s.id} to={`/buerger/sitzungen/${s.id}`} style={{ textDecoration: "none", color: "inherit" }}>
          <div className="card" style={{ padding: 16, marginBottom: 8, cursor: "pointer" }}>
            <div style={{ fontWeight: 600 }}>{s.titel}</div>
            <div style={{ fontSize: 13, color: "#666" }}>
              {s.datum ? new Date(s.datum).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" }) : "Datum offen"}
            </div>
          </div>
        </Link>
      ))}

      <h2 style={{ fontSize: 16, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>Vorlagen</h2>
      {vorlagen.length === 0 && (
        <div style={{ color: "#999", fontSize: 13 }}>Aktuell keine veröffentlichten Vorlagen.</div>
      )}
      {vorlagen.map(v => (
        <Link key={v.id} to={`/buerger/vorlagen/${v.id}`} style={{ textDecoration: "none", color: "inherit" }}>
          <div className="card" style={{ padding: 16, marginBottom: 8, cursor: "pointer" }}>
            <div style={{ fontWeight: 600 }}>{v.titel}</div>
            <div style={{ fontSize: 13, color: "#666" }}>
              {v.vorlagennummer && `${v.vorlagennummer} · `}{v.typ}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
